<template>
  <div class="result">
    <p class="search">搜索结果 <span @click="back">返回</span></p>
    <section @click="gotoEmployees(list.EMPLID)">
      <!-- <div class="divimg"><img :src="item.Photo" alt="" /></div> -->
      <div class="divimg">{{ list.NAME | cutName }}</div>
      <div class="divname">
        <p>
          {{ list.NAME }} <span style="color: #8f8f8f">{{ list.EMPLID }}</span>
        </p>
        <p style="color: #8f8f8f">
          {{ list.DEPT_DESCR }} <span>/</span> {{ list.POSN_DESCR }}
        </p>
      </div>
    </section>
  </div>
</template>
 
<script>
export default {
  props: ['list'],
  methods: {
    back() {
      this.$emit('goBack')
    },
    gotoEmployees(num) {
      this.$store.commit('changeNum', num)
      this.$router.push('/employees')
    },
  },
  filters: {
    cutName(val) {
      return val.slice(0, 1)
    },
  },
}
</script>
 
<style lang = "less" scoped>
.search {
  height: 44px;
  line-height: 44px;
  background: white;
  padding: 0 10px;
  margin-bottom: 10px;
  span {
    float: right;
    color: #2f78f6;
  }
}
section {
  background: white;
  font-size: 13px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  padding: 10px 10px;
  .divimg {
    width: 36px;
    height: 36px;
    border: 1px solid #b4b4b4;
    box-sizing: border-box;
    border-radius: 3px;
    img {
      width: 36px;
      height: 36px;
      overflow: hidden;
    }
    text-align: center;
    line-height: 36px;
    font-size: 18px;
    background: rgb(0, 149, 255);
    color: white;
  }
  .divname {
    margin-left: 20px;
    p {
      font-size: 14px;
      color: black;
      span {
        padding: 0 5px;
      }
    }
  }
}
</style>